exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  -ms-flex-align: center;\n      align-items: center;\n  background: #2b303b;\n  color: #ffffff;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: .8rem;\n  height: 2.93333333rem;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%; }\n  @media (max-width: 543px) {\n    :host {\n      font-size: .7rem; } }\n  :host .copyright,\n  :host .version {\n    padding: 10px 1.46666667rem; }\n  @media (max-width: 543px) {\n    :host .copyright {\n      padding-right: 0; }\n      .rtl :host .copyright {\n        padding-left: 0;\n        padding-right: 1.46666667rem; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ui/footer/footer.component.scss
// module id = ../../../../../src/app/ui/footer/footer.component.scss
// module chunks = 39